export enum DisputesStorageKeysEnum {
  ACTIVE_TAB = 'Disputes.ActiveTab',
}
